<template>
  <div v-if="showBattery" class="battery-status">
    <div
      class="battery-terminal"
      :style="{ backgroundColor: batteryColor }"
    ></div>
    <div class="battery" :style="{ borderColor: batteryColor }">
      <div
        class="battery-level"
        :style="{
          width: widthBatteryLevel,
          backgroundColor: batteryLevelColor,
        }"
      ></div>
      <div v-if="isBatteryEmpty" class="battery-empty"></div>
    </div>
    <div class="battery-percentage ml-1" :style="{ color: batteryLevelColor }">
      {{ batteryLevel }}%
    </div>
  </div>
</template>

<script>
export default {
  props: {
    batteryLevel: { Type: Number, default: null },
  },
  computed: {
    batteryColor() {
      return this.isBatteryEmpty ? "#7d7d7d" : "#f2f2f2";
    },
    widthBatteryLevel() {
      return this.batteryLevel + "%";
    },
    batteryLevelColor() {
      if (this.batteryLevel > 50) {
        return "#00FF7F";
      } else if (this.batteryLevel > 20) {
        return "#FFA500";
      } else if (this.batteryLevel >= 1) {
        return "#FF4500";
      } else {
        return "#7d7d7d";
      }
    },
    showBattery() {
      return this.batteryLevel !== null;
    },
    isBatteryEmpty() {
      return this.batteryLevel === 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.battery-status {
  width: 64px;
  display: flex;
  align-items: center;
  justify-content: start;
}

.battery {
  width: 24px;
  height: 14px;
  border: 1px solid;
  border-color: #f4f4f4;
  position: relative;
  display: flex;
  align-items: center;
  padding: 2px;
}

.battery-terminal {
  width: 2px;
  height: 6px;
  background-color: #f4f4f4;
}

.battery-level {
  height: 100%;
  background-color: green;
  transition: width 1s ease;
}

.battery-percentage {
  font-size: 12px;
}

.battery-empty {
  position: absolute;
  top: 40%;
  left: 1px;
  width: 100%;
  height: 2px;
  background-color: #7d7d7d;
  transform: rotate(50deg);
}
</style>
